import { ESystemType } from '@core/api';

/** table row中的按钮 */
export interface ITableOperator {
  /** 操作名称 */
  name: string;
  /**
   * 按钮类型
   * @default '''
  */
  type?: '' | 'primary' | 'success' | 'info' | 'warning' | 'danger';
  /** 权限code */
  code?: string;
  /**
   * 关联字段，用于控制按钮是否显示
   * @default undefined
   */
  relationField?: string;
  /**
   * 关联字段的值，用于控制按钮是否显示
   * @default undefined
   */
  relationValue?: any;
  /**
   * 关联字段的判断方式
   * @default 'equal'
   */
  relationFilter?: 'equal' | 'notEqual' | 'includes';
  /** 按钮显示的端场景 */
  systemType?: ESystemType[];
  /** 按钮事件 */
  action: (args: any) => void;
}

export const minOperatorsWidth = undefined;

export function initOperatorColumnStyle({ column }) {
  if (column.property === 'actions') {
    const widthArr: number[] = [];
    const actions = document.getElementsByClassName('table-row-btns');

    Array.prototype.forEach.call(actions, function(item) {
      let allBtnsWidth = 0;
      const children = item.children;

      const mw = (children.length - 1) * 24;

      for (const child of children) {
        allBtnsWidth += child.clientWidth;
      }

      const width = allBtnsWidth + mw + 18;

      widthArr.push(width < 106 ? 106 : width);
    });

    const w = widthArr.length > 0 ? Math.max(...widthArr) : 0;

    column.realWidth = w;
    column.minWidth = w;

    return {};
  }

  return {};
}
